import React, {useState, useEffect} from "react";
import "../../../../../sass/global/modals.scss";


export default function GeneralRequestModal({modalVisible, closeModal, registration, requestType, handleSubmitted}) {

    const [loading, setLoading] = useState('');
    const [text, setText] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {

        if (text.length === 0) {
            return setError('Text požiadavky je povinný');
        }

        setError('');
        setLoading(true);
        const data = new FormData;
        data.append('text', text);
        data.append('type', requestType);

        axios.post(`/api/${registration.id}/support-request`, data)
            .then(response => {
                setText('');
                handleSubmitted();
                closeModal();
            })
            .catch(e => console.error(e))
            .finally(() => setLoading(false))
    }

    return (
        <>
            {modalVisible === registration.id && (
                <>
                    <div className="backdrop"></div>
                    <div className="modal modal--m">
                        <div className="modal__header pb--0">
                            <h4 className="mb--s"><i className="fad fa-comments mr--xs text--primary"></i> Zaslať
                                požiadavku
                            </h4>

                            <button className={"modal__close"}
                                    onClick={closeModal}
                            >
                                <i className="fal fa-times"></i>
                            </button>
                        </div>

                        <form onSubmit={e => {
                            e.preventDefault();
                            handleSubmit();
                        }}>
                            <div className="modal__body">
                                <div className="modal__full gray">
                                    <p>Ak máte nejaké otázky alebo pripomienky, vyplňte, prosím, formulár nižšie a my
                                        Vás budeme obratom kontaktovať</p>
                                    <div className="input-container mt--s">
                                        <label className={'input__label'}>Text požiadavky</label>
                                        <textarea className="input__item textarea l"
                                                  value={text}
                                                  onChange={e => {
                                                      setText(e.target.value)
                                                  }}
                                        />
                                        {error.length > 0 && (
                                            <span className={'error-msg'}>{error}</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="modal__footer">

                                <button className={"btn btn--text btn--xs mr--xs"}
                                        disabled={loading}
                                        onClick={() => {
                                            if (loading) return;
                                            closeModal()
                                        }}
                                >
                                    Zrušiť
                                </button>

                                <button type="submit" className={"btn btn--primary btn--xs btn--shadow"} disabled={loading}>
                                    {
                                        loading ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin"/>
                                                &nbsp;
                                                Odosielam...
                                            </>
                                        ) : 'Odoslať'
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </>
            )
            }
        </>
    )
}
